import { ComponentStyleConfig } from '@chakra-ui/react';

export const Text: ComponentStyleConfig = {
    baseStyle: {
        marginBottom: 0
    }
};
